/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createSubscriptionResponseFromDiscriminatorValue, serializeCancelSubscriptionRequest, serializeSubscriptionResponse, type CancelSubscriptionRequest, type HttpValidationProblemDetails, type IError, type SubscriptionResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /billing/subscription/cancel
 */
export interface CancelRequestBuilder extends BaseRequestBuilder<CancelRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SubscriptionResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CancelSubscriptionRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SubscriptionResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CancelSubscriptionRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CancelRequestBuilderUriTemplate = "{+baseurl}/billing/subscription/cancel";
/**
 * Metadata for all the requests in the request builder.
 */
export const CancelRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CancelRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSubscriptionResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCancelSubscriptionRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
